// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"menuItem_menuItem__3yjOJ","is-active":"menuItem_is-active__3D0KQ"};